import React, { useState } from "react";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";

// ========================= COMPONENT BLOCKS =========================
const componentBlocks = {
  builtUpMembers: { icon: "BU", title: "Built-Up Members" },
  leftSideWall: { icon: "LSW", title: "Left Side Wall" },
  rightSideWall: { icon: "RSW", title: "Right Side Wall" },
  frontEndWall: { icon: "FEW", title: "Front End Wall" },
  backEndWall: { icon: "BEW", title: "Back End Wall" },
  roof01: { icon: "R1", title: "Roof-01" },
  roof02: { icon: "R2", title: "Roof-02" },
  pipeStrut: { icon: "PS", title: "Pipe Strut" },
  pipeBracing: { icon: "PB", title: "Pipe Bracing" },
  hr: { icon: "HRM", title: "HR" },
  portalBracing: { icon: "PBM", title: "Portal Bracing" },
  leanTo: { icon: "LT", title: "Lean-To" },
  canopy: { icon: "CP", title: "Canopy" },
  frameOpening: { icon: "FO", title: "Frame Opening" },
  partitionWall: { icon: "PW", title: "Partition Wall" },
  ridgeVentilator: { icon: "RV", title: "Ridge Ventilator" },
  turboFans: { icon: "TF", title: "Turbo Fans" },
  cageLadder: { icon: "CL", title: "Cage Ladder" },
  craneBeam: { icon: "CB", title: "Crane Beam" },
  mezzanine: { icon: "MZ", title: "Mezzanine" },
  fascia: { icon: "FA", title: "Fascia" },
  louvers: { icon: "LO", title: "Louvers" },
  structuralLouver: { icon: "SL", title: "Structural Louver" },
  industrialLouver: { icon: "IL", title: "Industrial Louver" },
  staircase: { icon: "SC", title: "Staircase" },
  handrail: { icon: "HRL", title: "Handrail" },
  hotRolled: { icon: "HR", title: "Hot Rolled" },
  others: { icon: "OT", title: "Others" },
};

// ========================= MAIN COMPONENT =========================
const EstimateUploadDataViewModal = ({
  show,
  onHide,
  data = [],
  columns = [],
  title = "Uploaded Data Preview",
  file,
  onClick,
  disabled = false,
  loading = false,
}) => {
  const [showSelectModal, setShowSelectModal] = useState(false);
  const [selectedComponents, setSelectedComponents] = useState([]);

  // const handleSave = () => {
  //   console.log("Selected Components:", selectedComponents);
  //   console.log(
  //     "Selected Component Titles:",
  //     selectedComponents.map((key) => componentBlocks[key].title)
  //   );

  //   if (typeof onClick === "function") {
  //     onClick(file);
  //   }
  // };
//   const handleSave = () => {
//     console.log(">>child component")
//   const toCamelCase = (str) => {
//     return str
//       .replace(/[-\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
//       .replace(/^./, (c) => c.toLowerCase());
//   };

//   const camelCaseTitles = selectedComponents.map(
//     (key) => toCamelCase(componentBlocks[key].title)
//   );

//   console.log("Selected Components (keys):", selectedComponents);
//   console.log("Selected Component Titles (camelCase):", camelCaseTitles);

//   if (typeof onClick === "function") {
//     onClick(file);
//   }
// };
const handleSave = () => {
  const toCamelCase = (str) => {
    return str
      .replace(/[-\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
      .replace(/^./, (c) => c.toLowerCase());
  };

  const camelCaseTitles = selectedComponents.map(
    (key) => toCamelCase(componentBlocks[key].title)
  );

  console.log("Selected Components (keys):", selectedComponents);
  console.log("Selected Component Titles (camelCase):", camelCaseTitles);

  if (typeof onClick === "function") {
    // 👉 Send both `file` and `camelCaseTitles` to parent
    onClick(file, camelCaseTitles);
  }
};


  const handleCheckboxChange = (key) => {
    setSelectedComponents((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  return (
    <>
      {/* =================== MAIN DATA VIEW MODAL =================== */}
      <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <DataTable
                columns={columns}
                data={data}
                pagination
                persistTableHead
                responsive
                striped
                highlightOnHover
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3 gap-2">
            <button
              className="btn btn-success"
              onClick={() => setShowSelectModal(true)}
            >
              Select Components
            </button>

            <button
              className="btn btn-success"
              onClick={handleSave}
              disabled={disabled || loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>

          {/* Show selected components below (optional) */}
          {selectedComponents.length > 0 && (
            <div className="mt-3">
              <strong>Selected Components:</strong>{" "}
              {selectedComponents
                .map((key) => componentBlocks[key].title)
                .join(", ")}
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* =================== SELECT COMPONENT MODAL =================== */}
      <Modal
        show={showSelectModal}
        onHide={() => setShowSelectModal(false)}
        size="lg"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Components</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {Object.entries(componentBlocks).map(([key, comp]) => (
              <Col xs={12} sm={6} md={4} lg={3} key={key} className="mb-2">
                <Form.Check
                  type="checkbox"
                  id={key}
                  label={`${comp.title} (${comp.icon})`}
                  checked={selectedComponents.includes(key)}
                  onChange={() => handleCheckboxChange(key)}
                />
              </Col>
            ))}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSelectModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EstimateUploadDataViewModal;
